import request from '@/utils/request';

// 门店管理（淘客）。门店是独立主体，淘客账号的「归属门店」就从这里取。
export function storeListApi(params) {
  return request({
    url: '/admin/distribution/store/list',
    method: 'GET',
    params: params
  });
}
export function storeDetailApi(id) {
  return request({
    url: "/admin/distribution/store/".concat(id),
    method: 'GET'
  });
}
export function storeOptionsApi(params) {
  return request({
    url: '/admin/distribution/store/options',
    method: 'GET',
    params: params
  });
}

// 团长下拉（给门店选负责人），按昵称/手机号远程搜
export function storeLeaderOptionsApi(params) {
  return request({
    url: '/admin/distribution/store/leader/options',
    method: 'GET',
    params: params
  });
}
export function storeSaveApi(data) {
  return request({
    url: '/admin/distribution/store/save',
    method: 'POST',
    data: data
  });
}
export function storeStatusApi(id, status) {
  return request({
    url: "/admin/distribution/store/status/".concat(id),
    method: 'POST',
    params: {
      status: status
    }
  });
}
export function storeDeleteApi(id) {
  return request({
    url: "/admin/distribution/store/".concat(id),
    method: 'DELETE'
  });
}

// 门店账号：本店信息（只认登录账号绑定的门店，与平台「门店管理」同一条记录）
export function storeMineApi() {
  return request({
    url: '/admin/distribution/store/mine',
    method: 'GET'
  });
}
export function storeMineSaveApi(data) {
  return request({
    url: '/admin/distribution/store/mine/save',
    method: 'POST',
    data: data
  });
}

// 门店账号提交的修改要平台审核：最近一条申请（审核中 / 已驳回 / 已通过）
export function storeMineChangeApi() {
  return request({
    url: '/admin/distribution/store/mine/change',
    method: 'GET'
  });
}
export function storeMineChangeWithdrawApi() {
  return request({
    url: '/admin/distribution/store/mine/change/withdraw',
    method: 'POST'
  });
}

// 经营类目：平台商户分类
export function storeBusinessCategoriesApi() {
  return request({
    url: '/admin/distribution/store/business-categories',
    method: 'GET'
  });
}

/** 本店签约合同：门店负责团长名下已完成的合同 */
export function storeMineContractsApi() {
  return request({
    url: '/admin/distribution/store/mine/contracts',
    method: 'GET'
  });
}